"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_hot_toast_1 = __importStar(require("react-hot-toast"));
var js_cookie_1 = __importDefault(require("js-cookie"));
var material_1 = require("@mui/material");
var react_router_dom_1 = require("react-router-dom");
var icons_material_1 = require("@mui/icons-material");
var react_hook_form_1 = require("react-hook-form");
var AxiosClient_1 = require("../../utils/AxiosClient");
var EditProduct = function () {
    var location = (0, react_router_dom_1.useLocation)();
    var product = location.state;
    var pro_images = product.pro_images;
    var token = js_cookie_1.default.get("token");
    document.title = "Products Management || !SHOP";
    var _a = (0, react_1.useState)(false), inAction = _a[0], setAction = _a[1];
    var _b = (0, react_1.useState)(pro_images), images = _b[0], setImages = _b[1];
    var navigate = (0, react_router_dom_1.useNavigate)();
    var deleteImg = function (imgId) {
        AxiosClient_1.AxiosClient.delete("/products/delete/image/".concat(imgId), {
            headers: { Authorization: "Bearer ".concat(token) },
        })
            .then(function (res) {
            if (res.data.status == 200) {
                pro_images = pro_images.filter(function (image) { return image.ImageID != imgId; });
                setImages(pro_images);
                react_hot_toast_1.default.success("Image Deleted");
            }
        })
            .catch(function (error) {
            console.log(error);
            react_hot_toast_1.default.error("Image not deleted");
        });
    };
    (0, react_1.useEffect)(function () {
        setImages(pro_images);
    }, [pro_images]);
    var formData = new FormData();
    var submit = function (data) {
        if (data.quantity <= 0 || data.p_price <= 0) {
            react_hot_toast_1.default.error("Quantity / Price must be greater than 0");
            return;
        }
        if (data.imgs.length === 0) {
            react_hot_toast_1.default.error("Please upload at least one image");
            return;
        }
        setAction(true);
        react_hot_toast_1.default.loading("Saving the new changes");
        formData.append("pname", data.pname);
        formData.append("p_price", data.p_price);
        formData.append("quantity", data.quantity);
        formData.append("desc", data.desc);
        for (var i = 0; i < data.imgs.length; i++) {
            var file = data.imgs[i];
            formData.append("imgs", file);
        }
        AxiosClient_1.AxiosClient.patch("/products/update/".concat(product.ProductID), formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer ".concat(token),
            },
        })
            .then(function (response) {
            react_hot_toast_1.default.remove();
            react_hot_toast_1.default.success(response.data.message, { duration: 5000 });
            console.log(response);
            setTimeout(function () {
                navigate("/seller-home");
            }, 4000);
        })
            .catch(function (error) {
            react_hot_toast_1.default.remove();
            react_hot_toast_1.default.error(error === null || error === void 0 ? void 0 : error.response.data.message, {
                duration: 10000,
            });
        })
            .finally(function () {
            setAction(false);
        });
    };
    var _c = (0, react_hook_form_1.useForm)(), register = _c.register, handleSubmit = _c.handleSubmit, control = _c.control, errors = _c.formState.errors;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.CssBaseline, null),
        react_1.default.createElement(material_1.Box, { sx: { display: "flex" } },
            react_1.default.createElement(material_1.Box, { component: "main", sx: { flexGrow: 1, pt: 10, pl: 2 } },
                react_1.default.createElement(material_1.Button, { variant: "outlined", component: react_router_dom_1.Link, to: "/seller-home", color: "info", startIcon: react_1.default.createElement(icons_material_1.ChevronLeft, null) }, "Back To View"),
                react_1.default.createElement(material_1.Container, { maxWidth: "xl" },
                    react_1.default.createElement(material_1.Grid, { container: true, spacing: 2, style: { display: "flex", justifyContent: "center" } },
                        react_1.default.createElement(material_1.Grid, { item: true, xs: 12, sm: 8, md: 6, lg: 6 },
                            react_1.default.createElement(material_1.Box, { sx: {
                                    boxShadow: "0 0 15px 0 rgba(0,0,0,.4)",
                                    mt: 2,
                                    borderRadius: "10px",
                                    p: 1,
                                } },
                                react_1.default.createElement(material_1.Typography, { align: "center", variant: "h6", sx: { fontWeight: "bold" } }, "UPDATE PRODUCT"),
                                react_1.default.createElement(material_1.Box, { mt: 5, px: 1 },
                                    react_1.default.createElement("form", { style: { textAlign: "center" }, id: "prodForm", encType: "multipart/form-data", onSubmit: handleSubmit(submit), noValidate: true, autoComplete: "off" },
                                        react_1.default.createElement(react_hook_form_1.Controller, { name: "pname", control: control, defaultValue: product.ProductName, rules: { required: true }, render: function (_a) {
                                                var field = _a.field;
                                                return (react_1.default.createElement(material_1.TextField, __assign({}, field, { sx: { mb: 2 }, label: "Product Name", error: Boolean(errors.pname), variant: "outlined", fullWidth: true, id: "pname", helperText: errors.pname
                                                        ? "Product Name can not be blank"
                                                        : null })));
                                            } }),
                                        react_1.default.createElement(react_hook_form_1.Controller, { name: "p_price", control: control, rules: { required: true }, defaultValue: product.ProductPrice, render: function (_a) {
                                                var field = _a.field;
                                                return (react_1.default.createElement(material_1.TextField, __assign({ sx: { mb: 1 } }, field, { type: "number", variant: "outlined", fullWidth: true, label: "Product Price", id: "price", InputProps: {
                                                        startAdornment: (react_1.default.createElement(material_1.InputAdornment, { position: "start" }, "FRW")),
                                                    }, error: Boolean(errors.p_price), helperText: errors.p_price
                                                        ? "How much your product cost?"
                                                        : null })));
                                            } }),
                                        react_1.default.createElement(react_hook_form_1.Controller, { name: "quantity", defaultValue: product.quantity, control: control, rules: { required: true }, render: function (_a) {
                                                var field = _a.field;
                                                return (react_1.default.createElement(material_1.TextField, __assign({ sx: { mb: 1 } }, field, { type: "number", variant: "outlined", fullWidth: true, label: "Product Quantity", id: "qty", error: Boolean(errors.quantity), helperText: errors.quantity ? "Provide the quantity" : null })));
                                            } }),
                                        react_1.default.createElement(react_hook_form_1.Controller, { name: "desc", control: control, defaultValue: product.ProductDesc, rules: { required: true }, render: function (_a) {
                                                var field = _a.field;
                                                return (react_1.default.createElement(material_1.TextField, __assign({ sx: { mb: 2 } }, field, { variant: "outlined", multiline: true, maxRows: 7, fullWidth: true, label: "Product Description", id: "desc", error: Boolean(errors.desc), helperText: errors.desc
                                                        ? "Tell us a bit about your product"
                                                        : null })));
                                            } }),
                                        react_1.default.createElement(material_1.Box, { sx: { textAlign: "left", mt: 2 }, className: "imageList", mb: 3 },
                                            react_1.default.createElement(material_1.Typography, { paragraph: true, color: "GrayText" }, "Product Images"),
                                            react_1.default.createElement(material_1.IconButton, { color: "info", "aria-label": "upload picture", component: "label" },
                                                react_1.default.createElement("input", __assign({}, register("imgs"), { hidden: true, accept: "image/*", multiple: true, type: "file" })),
                                                react_1.default.createElement(icons_material_1.AddAPhotoOutlined, null)),
                                            react_1.default.createElement(material_1.Box, null,
                                                react_1.default.createElement(material_1.ImageList, { variant: "quilted", sx: { width: "100%", height: 150 }, cols: 3, rowHeight: 150 }, images.map(function (img, index) { return (react_1.default.createElement(material_1.ImageListItem, { key: index },
                                                    react_1.default.createElement("img", { src: img.ImagePath, alt: product.ProductName, loading: "lazy", style: {
                                                            width: "100%",
                                                            height: "100%",
                                                            objectFit: "cover",
                                                            borderRadius: "10px",
                                                        } }),
                                                    react_1.default.createElement(material_1.ImageListItemBar, { actionIcon: react_1.default.createElement(material_1.IconButton, { color: "error", onClick: function () { return deleteImg(img.ImageID); }, "aria-label": "info about ".concat(product.ProductName) },
                                                            react_1.default.createElement(icons_material_1.Delete, null)) }))); })))),
                                        react_1.default.createElement(material_1.Button, { disabled: inAction, sx: { mb: 3 }, type: "submit", variant: "contained", startIcon: react_1.default.createElement(icons_material_1.PublishedWithChanges, null) }, "Save Changes"))))))))),
        react_1.default.createElement(react_hot_toast_1.Toaster, null)));
};
exports.default = EditProduct;
